import React, { Component } from 'react';
import { translate } from "react-translate";

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent'


import {
  Segment,
  Image,
  Container,
  Header,
  Grid,
} from 'semantic-ui-react';

import './support.css'

import image_hero from '../../../assets/img/faq.png';
import image_1 from '../../../assets/img/Calque_598.jpg';
// import image_2 from '../../../assets/img/Calque_605.jpg';
// import image_3 from '../../../assets/img/Calque_606.jpg';
import mur from '../../../assets/tmp/Murs_icon.png';

class SupportComponent extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
            <MenuComponent />

            <Segment vertical id="sectionSupport">
                <Image
                    src={image_hero}
                    id="sectionSupportImage"
                    fluid />
                <div id="containerSupport">
                    <Container textAlign='center'>
                        <Header size='huge' as='h1' id="containerSupportTitre">{t("Segment1_title")}</Header>
                    </Container>
                </div>
            </Segment>

            <Segment vertical id="sectionFaqContent">
                <Grid centered stackable padded>
                    <Grid.Row textAlign="center" columns={2}>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq1_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq1_description")}</p>
                            </Container>
                        </Grid.Column>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq2_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq2_description")}</p>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row textAlign="center" columns={2}>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq3_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq3_description")}</p>
                            </Container>
                        </Grid.Column>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq4_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq2_description")}</p>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row textAlign="center" columns={2}>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq5_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq5_description")}</p>
                            </Container>
                        </Grid.Column>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq6_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq6_description")}</p>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row textAlign="center" columns={2}>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq7_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq7_description")}</p>
                            </Container>
                        </Grid.Column>
                        <Grid.Column  mobile={16} tablet={7} computer={5}>
                            <Container id="sectionFaqContentTitle">
                                <Header as="h3" size='huge'>{t("faq8_title")}</Header>
                            </Container>
                            <Container textAlign="left" id="sectionFaqContentDescription" >
                                <p>{t("faq8_description")}</p>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

            <FooterComponent />
      </div>
    );
  }
}

export default translate("SupportComponent")(SupportComponent);



// WEBPACK FOOTER //
// ./src/components/Public/SupportPage/SupportComponent.js